import React, { PureComponent } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Nav.scss';
import { APP_ROOT_PATH } from './App';

import menuIcon from './assets/images/menu_icon_white.png';
import closeIcon from './assets/images/close.png';

class Nav extends PureComponent {
  state = {
    isOpen: false
  };

  handleMenuClick = () => {
    this.setState({ isOpen: true });
  };

  handleCloseClick = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { handleMenuClick, handleCloseClick } = this;
    const { isOpen } = this.state;

    return (
      <>
        <div className="menu-button-wrapper">
          <button
            className="menu-button"
            type="button"
            onClick={handleMenuClick}
          >
            <img src={menuIcon} alt="Open Navigation" />
          </button>
        </div>
        <CSSTransition in={isOpen} className="nav" timeout={300} unmountOnExit>
          <nav>
            <button
              className="close-button"
              type="button"
              onClick={handleCloseClick}
            >
              <img src={closeIcon} alt="Close Navigation" />
            </button>
            <ul className="nav-list">
              <li>
                <a
                  href="/TheWanderer/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
					收聽畫作故事
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ztoryteller.official"
                  target="_blank"
                  rel="noopener noreferrer"
                >
				{this.props.language === 'en' && (
						<>
							Follow ZtoryTeller
						</>
					 )}
					{this.props.language !== 'en' && (
						<>
							Follow ZtoryTeller
						</>
					)}
                  
				  
                </a>
              </li>
            </ul>
          </nav>
        </CSSTransition>
      </>
    );
  }
}

export default Nav;
